const InsightRow = ({ label, value, testId }) => (
  <div className="rounded-[18px] border border-[#D4AF37]/18 bg-white px-4 py-3" data-testid={testId}>
    <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#8b6d16]">{label}</p>
    <p className="mt-2 text-sm leading-7 text-[#001935]">{value}</p>
  </div>
);

export const AdvisorDistrictIntelligencePanel = ({ intelligence }) => {
  if (!intelligence) return null;

  return (
    <div className="rounded-[24px] border border-[#D4AF37]/25 bg-[#fffaf1] px-5 py-5 shadow-[0_12px_30px_rgba(0,25,53,0.08)]" data-testid="signature-advisor-district-intelligence-panel">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="signature-advisor-district-intelligence-eyebrow">District intelligence narrative</p>
      <h4 className="mt-2 text-xl font-semibold text-[#001935]" data-testid="signature-advisor-district-intelligence-headline">{intelligence.headline}</h4>
      <p className="mt-2 text-sm leading-7 text-[#5f5a4e]" data-testid="signature-advisor-district-intelligence-summary">{intelligence.summary}</p>

      <div className="mt-4 grid gap-3 md:grid-cols-2" data-testid="signature-advisor-district-intelligence-grid">
        <InsightRow label="Demand profile" testId="signature-advisor-district-intelligence-demand" value={intelligence.demand_profile} />
        <InsightRow label="Catalyst" testId="signature-advisor-district-intelligence-catalyst" value={intelligence.catalyst} />
        <InsightRow label="Caution" testId="signature-advisor-district-intelligence-caution" value={intelligence.caution} />
        <InsightRow label="Best for" testId="signature-advisor-district-intelligence-best-for" value={intelligence.best_for} />
      </div>
    </div>
  );
};